// tslint:disable:no-any
// tslint:disable:jsx-no-string-ref

import React, { Component } from 'react';
import { Redirect } from 'react-router';
import Footer from '../components/Footer';
import CookieConsent from '../components/CookieConsent';
import Title from '../components/Title';
import PublicHeader from '../components/PublicHeader';

export interface IPrivacyPolicyProps {}
interface IPrivacyPolicyState {
    height: number;
    scrollTo: any;
}
class PrivacyPolicy extends Component<
    IPrivacyPolicyProps,
    IPrivacyPolicyState
> {
    constructor(props: IPrivacyPolicyProps) {
        super(props);
        this.state = {
            height: 600,
            scrollTo: null
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = 'WetNotes | Privacy Policy';
    }

    componentWillMount() {
        this.setState({
            height: window.innerHeight - 525
        });
    }

    scrollTo(refName: any) {
        this.setState({
            scrollTo: refName
        });
    }

    render() {
        return (
            <div className="privacy-policy">
                <PublicHeader scrollTo={e => this.scrollTo(e)} />

                {this.state.scrollTo && (
                    <Redirect
                        to={{
                            pathname: '/',
                            state: {
                                scrollTo: this.state.scrollTo
                            }
                        }}
                    />
                )}

                <Title />

                <section style={{ minHeight: this.state.height }}>
                    <div className="wrapper">
                        <h1>Privacy Policy</h1>
                        <p>The text is being prepared...</p>
                    </div>
                </section>

                <Footer ref="footer" logged={false} />

                <CookieConsent />
            </div>
        );
    }
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/PrivacyPolicy.tsx